const prefix = "catalog/materials";

export const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
export const FETCH_FAILED = `${prefix}/FETCH_FAILED`;
export const FETCH_ENDED = `${prefix}/FETCH_ENDED`;
export const RESET = `${prefix}/RESET`;

export const SET_SEARCH_TERM = `${prefix}/SET_SEARCH_TERM`;
export const SET_SEARCH_TERM_INITIAL = `${prefix}/SET_SEARCH_TERM_INITIAL`;
export const SET_SEARCH_TABLE = `${prefix}/SET_SEARCH_TABLE`;

export const SET_FILTER = `${prefix}/SET_FILTER`;
// export const SET_PAGER = `${prefix}/SET_PAGER`;
export const SET_LIMIT = `${prefix}/SET_LIMIT`;

export const SET_MANUFACTURER = `${prefix}/SET_MANUFACTURER`;
export const SET_PART_TYPE = `${prefix}/SET_PART_TYPE`;
export const SET_SPARE_PART_TYPE = `${prefix}/SET_SPARE_PART_TYPE`;
export const SET_SEARCH_LOCATION = `${prefix}/SET_SEARCH_LOCATION`;

export const SAVE_FILTER_SETTINGS = `${prefix}/SAVE_FILTER_SETTINGS`;
export const RESTORE_FILTER_SETTINGS = `${prefix}/RESTORE_FILTER_SETTINGS`;

export const PAGER_DEFAULT_LIMIT = 50;
export const PAGER_DEFAULT_SORT = "name";
export const PAGER_DEFAULT_DIR = "asc";
